import api from './api'

export const blogService = {
  getAll: async (params = {}) => {
    const res = await api.get('/blog/admin', { params })
    return res.data
  },

  getById: async (id) => {
    const res = await api.get(`/blog/admin/${id}`)
    return res.data.data
  },

  create: async (payload) => {
    const res = await api.post('/blog', payload)
    return res.data.data
  },

  update: async (id, payload) => {
    const res = await api.patch(`/blog/${id}`, payload)
    return res.data.data
  },

  remove: async (id) => {
    const res = await api.delete(`/blog/${id}`)
    return res.data
  },
}
